// extracted by mini-css-extract-plugin
export default {"boxLink":"BoxShareLink_boxLink__tBX81","linkText":"BoxShareLink_linkText__LdAD7","share":"BoxShareLink_share__70k6X"};